import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {Uat, UpdateUat} from './uat.interface';
import {Judet} from "../judet/judet.interface";

@Injectable({
  providedIn: 'root',
})
export class UatService {
  private token!: string;
  private basePath = environment.interop.basePath;
  private getUatDTUrl =
    this.basePath +
    environment.interop.dgitl.nomenclatoare.uat.getUatDT;
  private storeUatURL =
    this.basePath +
    environment.interop.dgitl.nomenclatoare.uat.storeUat;

  private deleteStoreUat =
    this.basePath +
    environment.interop.dgitl.nomenclatoare.uat.deleteUat;

  // private getStatusActive =
  //   this.basePath +
  //   environment.interop.urbanism.nomenclatoare.uat
  //     .getUatActive;

  // private getStatusPublic =
  //   this.basePath +
  //   environment.interop.urbanism.nomenclatoare.uat
  //     .getUatsActivePublic;

  private updateUatStore =
    this.basePath +
    environment.interop.dgitl.nomenclatoare.uat.putUat;

  private httpOptions: any;

  constructor(private http: HttpClient) {
  }

  getStatusDT() {
    return this.http.get(this.getUatDTUrl, this.httpOptions);
  }

  addUat(uat: { denumire_institutie: any }) {
    return this.http.post(this.storeUatURL, uat, this.httpOptions);
  }

  storeStatus(data: Uat) {
    return this.http.post(this.storeUatURL, data, this.httpOptions);
  }

  // getActiveStatus() {
  //   return this.http.get(this.getUatActive, this.httpOptions);
  // }
  //
  // getPublicStatus() {
  //   return this.http.get(this.getUatPublic, this.httpOptions);
  // }

  updateUat(updateUat: UpdateUat) {
    return this.http.put(
      this.updateUatStore,
      updateUat,
      this.httpOptions
    );
  }

  deleteUat(sectionId: number) {
    return this.http.delete(this.deleteStoreUat + sectionId);
  }

  setToken(token: string) {
    this.token = token;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${this.token}`,
      }),
    };
  }
}
